/** The brand-gradient full-width CTA button reused across every Variant B question/interstitial page. */

import React from "react";
import { useShellId } from "./shellContext";

interface PrimaryCtaButtonProps {
  label: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

const PrimaryCtaButton: React.FC<PrimaryCtaButtonProps> = ({ label, onClick, disabled, className, id }) => {
  // QuestionFrame renders the CTA in both shells; scope the id so a mobile
  // click doesn't land on the hidden desktop copy.
  const shellId = useShellId(id);
  return (
  <button
    id={shellId}
    className={`w-full h-[54px] rounded-[16px] font-semibold text-base flex items-center justify-center transition-all duration-100${
      disabled
        ? " text-[#9ca3af] cursor-not-allowed"
        : " text-white cursor-pointer hover:opacity-90 active:scale-[0.96]"
    }${className ? ` ${className}` : ""}`}
    style={{
      background: disabled
        ? "#e5e7eb"
        : "linear-gradient(90deg, #f59200 0%, #ffbb29 100%)",
      border: "none",
    }}
    onClick={onClick}
    disabled={disabled}
  >
    {label}
  </button>
  );
};

export default PrimaryCtaButton;
